type AnyFn = (...args: any[]) => any;

export interface Listener {
	addListener(eventName: string, handler: AnyFn): google.maps.MapsEventListener;
}

export function isListener(object: any): object is Listener {
	return typeof object?.addListener === "function";
}
